export default "__VITE_ASSET__BTFwmNH0__"